import { render, staticRenderFns } from "./MidiaPreview.vue?vue&type=template&id=4197b2cf&scoped=true"
import script from "./MidiaPreview.vue?vue&type=script&lang=js"
export * from "./MidiaPreview.vue?vue&type=script&lang=js"
import style0 from "./MidiaPreview.vue?vue&type=style&index=0&id=4197b2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197b2cf",
  null
  
)

export default component.exports